import React, { useEffect } from 'react'
import { getCLS, getFID, getLCP, ReportHandler } from 'web-vitals'
import Picasso, { Page } from '@toptal/picasso'
import Header from './components/Header'
import Combinations from './components/Combinations'
import ExtraOptions from './components/ExtraOptions'
import Hero from './components/Hero'
import MergeButton from './components/MergeButton'
import MergeInputs from './components/MergeInputs'
import TrackedResults from './components/TrackedResults'
import Social from './components/Social'
import texts from './texts.json'

import { scrollNowChanged } from './actions'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { IStoreState } from './utils'
import InternalLinks from './components/InternalLinks/InternalLinks'

const sendToGoogleAnalytics: ReportHandler = ({ name, delta, id }) => {
  window.gtag('event', name, {
    event_category: 'web_vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true
  })
}

const App: React.FunctionComponent<{}> = (props: any) => {
  useEffect(() => {
    if (!props.scrollNow) return

    const combinationsSection: HTMLDivElement | null = document.querySelector(
      '#combinations'
    )

    if (combinationsSection) {
      window.scrollTo(0, combinationsSection.offsetTop)
      props.alreadyScrolled()
    }
  })

  useEffect(() => {
    getCLS(sendToGoogleAnalytics)
    getFID(sendToGoogleAnalytics)
    getLCP(sendToGoogleAnalytics)
  }, [])

  return (
    <Picasso>
      <Page>
        <Header />
        <Page.Content
          style={{
            maxWidth: 1000,
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Hero {...texts.hero} />
          <MergeInputs />
          <ExtraOptions title={texts.extraOptions.title} />
          <div id='combinations'>
            <Combinations />
          </div>
          <MergeButton label={texts.mergeButton.label} />
          <TrackedResults />
        </Page.Content>
        <InternalLinks />
        <Page.Footer rightContent={<Social />} />
      </Page>
    </Picasso>
  )
}

const mapStateToProps = (state: IStoreState) => ({
  scrollNow: state.scrollNow
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  alreadyScrolled: () => {
    dispatch(scrollNowChanged(false))
  }
})

const AppSmart = connect(mapStateToProps, mapDispatchToProps)(App)

export default AppSmart
